/* global $:false */

import 'modernizr.js'
import { isAppRequest } from 'src/public/app_request.js'

export default class Favorites {
  static init () {
    if (window.Modernizr.touchevents && !isAppRequest()) { this.showForTouch() }
  }

  static showForTouch () {
    $(window.document).find('.c-favoring-toggler__icon--neutral')
        .css('visibility', 'visible')
  }
}
